// extracted by mini-css-extract-plugin
module.exports = {"DotsContainer":"TopicDots_DotsContainer__3tZ50","Dot":"TopicDots_Dot__oeBqL","DotMask":"TopicDots_DotMask__2g1dL","playMask":"TopicDots_playMask__t54k9"};